import React from 'react'
import { useNavigate } from 'react-router-dom'
import { hasSessionToken } from 'utils/session'
import logo from './images/logo.png'

/**
 * Logo Life cliquable — comportement unifié partout où le logo apparaît :
 * - session présente (token) → page d'accueil `/`
 * - pas de session → page de connexion `/login`
 *
 * On teste le token via hasSessionToken() (utils/session) et non le store :
 * `setSiteUser({})` laisse un objet truthy après déconnexion (piège connu).
 */
export default function LifeLogo({ style, alt = 'Life', ...props }) {
  const navigate = useNavigate()
  return (
    <img
      src={logo}
      alt={alt}
      onClick={() => navigate(hasSessionToken() ? '/' : '/login')}
      style={{ cursor: 'pointer', ...style }}
      {...props}
    />
  )
}
